import React from "react";
import AdminWebsiteOverview from "./AdminWebsiteOverview";
import CustomerServiceWebsiteOverview from "./CustomerServiceWebsiteOverview";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";

const InterfacesAndComponentsOverview = ({ data }) => {
  if (!data) return <DataNotFound />;

  return (
    <React.Fragment>
      <AdminWebsiteOverview data={data} />
      <div className="mb-16"></div>
      <CustomerServiceWebsiteOverview data={data} />
    </React.Fragment>
  );
};
export default InterfacesAndComponentsOverview;
